import moment from 'moment';

import { SearchBarDateType } from '@utils/dateUtil';

export const formatDate = (date: SearchBarDateType | undefined) =>
  date ? moment(date).format('YYYY-MM-DD') : '';
